/* app/js/src/components/calendar/calendar-video.component.scss */
.cursor-pointer {
  cursor: pointer;
}
:host {
  position: absolute;
  right: 0;
  left: 0;
  margin-right: 15px;
}
.video {
  cursor: pointer;
  margin-bottom: 3px;
  height: 100%;
  position: relative;
  z-index: 1;
}
.video.highlight {
  z-index: 2;
}
.video.highlight .background {
  -ms-transform: scale(1.01, 1.02);
  -webkit-transform: scale(1.01, 1.02);
  transform: scale(1.01, 1.02);
  -webkit-box-shadow: 0 0 10px 2px rgba(0, 0, 0, 0.2);
  -moz-box-shadow: 0 0 10px 2px rgba(0, 0, 0, 0.2);
  box-shadow: 0 0 10px 2px rgba(0, 0, 0, 0.2);
}
.video.highlight .search-indicator-sub-items {
  -ms-transform: translateY(0);
  -webkit-transform: translateY(0);
  transform: translateY(0);
  opacity: 1;
}
.video .background {
  background-color: #d7f2ff;
  border: solid 1px #aee5ff;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 5;
  box-shadow: none;
  -ms-transform: scale(1, 1);
  -webkit-transform: scale(1, 1);
  transform: scale(1, 1);
  -webkit-transition: all 0.2s cubic-bezier(0.6, 0.04, 0.54, 0.99);
  transition: all 0.2s cubic-bezier(0.6, 0.04, 0.54, 0.99);
}
.video .background.background-live-feed {
  background-color: #ffcccc;
}
.video .video-details {
  position: relative;
  z-index: 6;
  display: flex;
  align-items: center;
  font-size: 12px;
  line-height: 1.5;
  letter-spacing: -0.1px;
  color: #232f3a;
  padding-top: 4px;
}
.video .video-details .thumbnail {
  margin: 0 4px 0 4px;
  background-color: black;
  width: 82px;
  height: 47px;
}
.video .video-details .thumbnail img {
  width: 82px;
  height: 47px;
  border: solid 1px #ffffff;
}
.video .video-details .title {
  flex: 1;
  margin-left: 5px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.video .video-details .capsule {
  border-radius: 11px;
  display: flex;
  align-items: center;
  margin-right: 6px;
  transition: all 0.2s ease;
}
.video .video-details .capsule .capsule-icon {
  background-size: contain;
  background-repeat: no-repeat;
  margin: 0 4px 0 7px;
}
.video .video-details .capsule .capsule-name {
  min-width: 30px;
  margin-right: 4px;
}
.video .video-details .capsule .capsule-count {
  font-size: 9px;
  line-height: 1;
  text-align: center;
  border-radius: 7.5px;
  margin: 2px;
  padding: 3px 5px;
}
.video .video-details .capsule.ads {
  background-color: #ffe707;
}
.video .video-details .capsule.ads .capsule-icon {
  width: 11px;
  height: 11px;
  background-image: url(/assets/icons/ads.svg);
}
.video .video-details .capsule.ads .capsule-count {
  background-color: #fbd70f;
}
.video .video-details .capsule.graphics {
  color: white;
  background-color: #a65bfa;
}
.video .video-details .capsule.graphics .capsule-icon {
  width: 18px;
  height: 13px;
  background-image: url(/assets/icons/capsule-graphics-icon.svg);
}
.video .video-details .capsule.graphics .capsule-count {
  background-color: #853eea;
}
.video .video-details .capsule.subtitles {
  color: white;
  background-color: #40c4ff;
}
.video .video-details .capsule.subtitles .capsule-icon {
  width: 12px;
  height: 8px;
}
.video .video-details .capsule.subtitles .capsule-count {
  background-color: #16abe4;
  text-transform: uppercase;
}
.video .video-details .capsule.subtitles.active,
.video .video-details .capsule.subtitles:hover {
  color: #232f3a;
  background-color: white;
}
.video .video-details .capsule.subtitles.active .capsule-count,
.video .video-details .capsule.subtitles:hover .capsule-count {
  background-color: #f5f9fd;
}
.video .video-details .capsule.subtitles.active .capsule-icon ::ng-deep svg path,
.video .video-details .capsule.subtitles:hover .capsule-icon ::ng-deep svg path {
  fill: #232f3a;
}
.video .video-details .video-hours {
  display: flex;
  align-items: center;
  font-size: 10px;
  letter-spacing: 0px;
  color: #232f3a;
  margin: 0 8px 0 0;
  font-family: Open Sans;
  font-weight: bold;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.8;
  text-align: left;
}
.video .search-indicator-sub-items {
  position: absolute;
  background-color: #232f3a;
  bottom: 170%;
  color: #fff;
  left: 10px;
  padding: 5px 10px;
  font-size: 0.5em;
  border-radius: 8px;
  top: auto;
  opacity: 0;
  -webkit-transition: all 0.2s cubic-bezier(0.6, 0.04, 0.54, 0.99);
  transition: all 0.2s cubic-bezier(0.6, 0.04, 0.54, 0.99);
  -webkit-transition-delay: 150ms;
  transition-delay: 150ms;
  -ms-transform: translateY(10px);
  -webkit-transform: translateY(10px);
  transform: translateY(10px);
  -webkit-animation-delay: 0;
  -webkit-animation-duration: 0.2s;
  -webkit-animation-name: videoTooltipEnter;
  -webkit-animation-fill-mode: forwards;
  -webkit-animation-iteration-count: 1;
  -moz-animation-delay: 0;
  -moz-animation-duration: 0.2s;
  -moz-animation-name: videoTooltipEnter;
  -moz-animation-fill-mode: forwards;
  -moz-animation-iteration-count: 1;
  -o-animation-delay: 0;
  -o-animation-duration: 0.2s;
  -o-animation-name: videoTooltipEnter;
  -o-animation-fill-mode: forwards;
  -o-animation-iteration-count: 1;
  animation-delay: 0;
  animation-duration: 0.2s;
  animation-name: videoTooltipEnter;
  animation-fill-mode: forwards;
  animation-iteration-count: 1;
}
.video .search-indicator-sub-items::after {
  content: " ";
  position: absolute;
  bottom: -9px;
  left: calc(50% - 5px);
  border-top: 5px solid #232f3a;
  border-right: 5px solid rgba(0, 0, 255, 0);
  border-left: 5px solid rgba(255, 0, 0, 0);
  border-bottom: 5px solid rgba(128, 0, 128, 0);
}
.video.small-width .video-details .thumbnail,
.video.medium-height .video-details .thumbnail,
.video.small-height .video-details .thumbnail,
.multiple .thumbnail {
  display: none;
}
.video.small-width .video-details .capsule-icon,
.video.small-width .video-details .capsule-name,
.video.small-width .video-details .video-hours {
  display: none;
}
.video.small-width .video-details .capsule-count {
  margin: 0;
}
.video.small-height .capsule {
  display: none;
}
.video.small-height .title {
  display: none;
}
.video.small-height .video-hours {
  display: none;
}
.video.medium-height {
  padding-top: 0;
}
.video.medium-height .video-details {
  position: relative;
  width: 100%;
  top: 50%;
  transform: translate(0, -50%);
}
.video.medium-height .video-details .title {
  margin-top: -7px;
  line-height: 1;
}
.video.medium-height .video-details .title .video-hours {
  line-height: 1.4;
}
.video.medium-height .capsule-icon,
.video.medium-height .capsule-name {
  display: none;
}
@keyframes videoTooltipEnter {
  from {
    opacity: 0;
    -ms-transform: translateY(10px);
    -webkit-transform: translateY(10px);
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    -ms-transform: translateY(0);
    -webkit-transform: translateY(0);
    transform: translateY(0);
  }
}
.live-feed-icon ::ng-deep svg,
.anchor-icon ::ng-deep svg {
  width: 15px;
  height: 15px;
  fill: #40c4ff;
  margin-right: 6px;
}
.duration-adjuster {
  position: absolute;
  transform: translateY(-15px);
  background: transparent;
  height: 20px;
  width: 100%;
  z-index: 2;
}
.duration-adjuster:hover {
  cursor: n-resize;
}
.background-contract {
  background-color: #eef2f6 !important;
  border: solid 1px #bccad8 !important;
}
.sec-event-indicator-icons {
  display: flex;
  flex-direction: row;
}
.sec-event-icon {
  display: flex;
  align-items: center;
  margin-right: 13px;
}
.sec-event-inactive ::ng-deep svg path {
  fill: #7d8fa1;
  opacity: 50%;
}
.sec-events-popup {
  z-index: 100000;
  overflow: visible;
}
.sec-events-popup-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 60px;
}
.video.small-height .sec-events-popup-container,
.video.small-width .sec-events-popup-container,
.video.medium-height .sec-events-popup-container {
  display: none;
}
/*# sourceMappingURL=calendar-video.component.css.map */
